import { render, staticRenderFns } from "./Comics.vue?vue&type=template&id=330adc3a&scoped=true&"
import script from "./Comics.vue?vue&type=script&lang=ts&"
export * from "./Comics.vue?vue&type=script&lang=ts&"
import style0 from "./Comics.vue?vue&type=style&index=0&id=330adc3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330adc3a",
  null
  
)

export default component.exports